// Get base URL for public assets
export const getBaseUrl = (): string => {
  // Check if a base URL is provided as a data attribute
  const dataBaseUrl = document.body.getAttribute("data-base-url");
  if (dataBaseUrl) {
    return dataBaseUrl.replace(/\/$/, ""); // Remove trailing slash
  }

  // Try to detect the script's origin from current script tags
  const scripts = document.querySelectorAll(
    'script[src*="import-installations-ui"]',
  );
  if (scripts.length > 0) {
    const scriptSrc = (scripts[0] as HTMLScriptElement).src;
    const url = new URL(scriptSrc);
    return `${url.protocol}//${url.host}`;
  }
  // Fallback to current origin
  return window.location.origin;
};
